import { type RouteRecordRaw } from 'vue-router'

export const AttendeesWhiteListRouter: RouteRecordRaw[] = [
  {
    path: '/attendee-white-list-create',
    component: async () => import('./AttendeeWhiteListCreate.vue'),
  },
  {
    path: '/attendee-white-list',
    component: async () => import('./AttendeeWhiteListList.vue'),
  },
]
